/* Golden Beak – native product page (replaces GemPages runtime) */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-gb-gallery]');
    if (!gallery || gallery.dataset.ready) return null;
    gallery.dataset.ready = '1';
    var main = gallery.querySelector('[data-gb-main]');
    var slides = Array.prototype.slice.call(main.children);
    var thumbsBox = gallery.querySelector('[data-gb-thumbs]');
    var thumbs = thumbsBox ? Array.prototype.slice.call(thumbsBox.children) : [];
    var current = 0;

    function setActiveThumb(i) {
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
      var t = thumbs[i];
      if (!t || !thumbsBox) return;
      var vertical = getComputedStyle(thumbsBox).flexDirection === 'column';
      if (vertical) {
        var top = t.offsetTop - (thumbsBox.clientHeight - t.offsetHeight) / 2;
        thumbsBox.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        var left = t.offsetLeft - (thumbsBox.clientWidth - t.offsetWidth) / 2;
        thumbsBox.scrollTo({ left: left, behavior: 'smooth' });
      }
    }

    function goTo(i, instant) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length; // loop
      current = i;
      main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActiveThumb(i);
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { goTo(idx); });
    });
    var prev = gallery.querySelector('[data-gb-prev]');
    var next = gallery.querySelector('[data-gb-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // keep thumbs in sync when the shopper swipes the main image
    var raf;
    main.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(main.scrollLeft / Math.max(main.clientWidth, 1));
        if (i !== current && slides[i]) { current = i; setActiveThumb(i); }
      });
    }, { passive: true });

    return {
      goToMedia: function (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].dataset.mediaId) === String(mediaId)) { goTo(i); return; }
        }
      }
    };
  }

  function initMarquee(root) {
    root.querySelectorAll('.gb-marquee').forEach(function (mq) {
      if (mq.dataset.ready) return;
      mq.dataset.ready = '1';
      var container = mq.querySelector('.rfm-marquee-container');
      var first = container && container.querySelector('.rfm-marquee:not(.placeholder-marquee)');
      if (!first) return;
      container.querySelectorAll('.placeholder-marquee').forEach(function (p) { p.remove(); });
      var group = first.querySelector('.rfm-initial-child-container');
      var child = group && group.querySelector('.rfm-child');
      function build() {
        if (!group || !child) return;
        // fill at least the container width with copies of the items
        while (group.children.length > 1) group.removeChild(group.lastChild);
        var cw = container.clientWidth;
        var w = child.getBoundingClientRect().width || 1;
        var copies = Math.max(1, Math.ceil(cw / w));
        for (var i = 1; i < copies; i++) group.appendChild(child.cloneNode(true));
        container.querySelectorAll('.rfm-marquee').forEach(function (m, idx) { if (idx > 0) m.remove(); });
        var clone = first.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
        var dist = first.getBoundingClientRect().width;
        var speed = parseFloat(mq.dataset.speed || '50'); // px per second
        [first, clone].forEach(function (m) { m.style.setProperty('--duration', (dist / speed) + 's'); });
      }
      build();
      var t;
      window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 200); });
    });
  }

  function initProduct(root) {
    if (root.dataset.gbReady) return;
    root.dataset.gbReady = '1';

    var gallery = initGallery(root);
    initMarquee(root.closest('.gb-pdp-wrap') || document);

    var dataEl = root.querySelector('[data-gb-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var moneyFormat = root.dataset.moneyFormat;
    var form = root.querySelector('form[data-gb-form]');
    var idInput = form && form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-gb-price]');
    var atc = root.querySelector('[data-gb-atc]');
    var soldOut = root.querySelector('[data-gb-soldout]');
    var errorEl = root.querySelector('[data-gb-error]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-gb-variants] [data-option-position]'));

    function selectedOptions() {
      return groups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return opts.every(function (o, i) { return o === null || v.options[i] === o; });
      });
    }

    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('label').forEach(function (label) {
          var input = label.querySelector('input');
          var test = opts.slice();
          test[gi] = input.value;
          var v = findVariant(test);
          label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function updateVariant(variant) {
      if (!variant) {
        if (atc) { atc.disabled = true; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price, moneyFormat);
      var atcWrap = root.querySelector('[data-gb-atc-wrap]');
      var soldWrap = root.querySelector('[data-gb-soldout-wrap]');
      if (atcWrap) atcWrap.hidden = !variant.available;
      if (soldWrap) soldWrap.hidden = variant.available;
      if (atc) atc.disabled = !variant.available;
      if (variant.featured_media && gallery) gallery.goToMedia(variant.featured_media.id);
      if (root.dataset.updateUrl !== 'false' && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('gb:variant-change', { bubbles: true, detail: { variant: variant } }));
    }

    groups.forEach(function (g) {
      g.addEventListener('change', function () {
        var opts = selectedOptions();
        markAvailability(opts);
        updateVariant(findVariant(opts));
      });
    });
    if (groups.length) markAvailability(selectedOptions());

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!atc || atc.disabled) return;
        if (errorEl) errorEl.hidden = true;
        atc.setAttribute('aria-busy', 'true');
        atc.dataset.state = 'loading';
        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status) throw new Error(res.description || res.message || 'Cannot add product to cart');
            return fetch(root_url + 'cart.js').then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            var drawer = document.querySelector('cart-drawer-component');
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'gb-pdp-' + product.id,
                data: { source: 'gb-pdp', itemCount: cart.item_count, productId: String(product.id) }
              }
            }));
            if (drawer && typeof drawer.open === 'function') {
              if (!drawer.hasAttribute('auto-open')) drawer.open();
            } else {
              window.location.href = root_url + 'cart';
            }
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          })
          .finally(function () {
            atc.removeAttribute('aria-busy');
            atc.dataset.state = 'idle';
          });
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gb-pdp]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-gb-static-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
